import script from "./PbxSiteRotateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PbxSiteRotateModal.vue?vue&type=script&setup=true&lang=js"

import "./PbxSiteRotateModal.vue?vue&type=style&index=0&id=5a00c500&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a00c500"]])

export default __exports__